import { Select, Spin } from "antd";
import React, { useState, useEffect } from "react";
import { Link, useNavigate } from "react-router-dom";
import { ROLL_CALL_API_BASE_URL } from "../RollCallConfig/RollCallConfig";

const Permissions = () => {
  const navigate = useNavigate();

  const [subMenu, setSubMenu] = useState([]);
  const [selectedSubMenu, setSelectedSubMenu] = useState(null);
  const [permissions, setPermissions] = useState([]);
  const [permissionLoading, setPermissionLoading] = useState(false);
  const [modules, setModules] = useState([]);
  const [selectedModule, setSelectedModule] = useState(null);
  const [roles, setRoles] = useState([]);
  const [selectedRole, setSelectedRole] = useState(null);
  const [tokenData, setTokenData] = useState(null);
  const [superIdData, setSuperIdData] = useState(null);
  const [updateLoading, setUpdateLoading] = useState(false);

  useEffect(() => {
    const token = sessionStorage.getItem("authToken");
    const superId = sessionStorage.getItem("superId");

    if (token && superId) {
      setTokenData(token);
      setSuperIdData(superId);
    } else {
      console.warn("User data not found in sessionStorage");
      navigate("/signin");
    }
    console.log(superIdData);
  }, [navigate]);

  const fetchModules = async () => {
    try {
      const res = await fetch(
        `${ROLL_CALL_API_BASE_URL}portal/access/getModules`,
        {
          method: "GET",
          headers: {
            "Content-Type": "application/json",
            Authorization: `Bearer ${tokenData}`,
          },
        }
      );
      const data = await res.json();

      if (data?.status && Array.isArray(data?.ResultData)) {
        setModules(data.ResultData);
      }
    } catch (error) {
      console.error("Error fetching modules:", error);
    }
  };

  useEffect(() => {
    fetchModules();
  }, []);

  const handleModuleChange = (value) => {
    setSelectedModule(value);
  };

  const fetchPermissions = async () => {
    if (!selectedModule || !selectedRole) {
      return;
    }

    try {
      setPermissionLoading(true);
      const res = await fetch(
        `${ROLL_CALL_API_BASE_URL}portal/access/getPermissions?RoleId=${selectedRole}&SuperId=10000&subMenuId=${selectedSubMenu}&ModuleId=${selectedModule}`
      );
      const data = await res.json();

      if (data?.Status !== false && Array.isArray(data?.ResultData)) {
        const formatted = data.ResultData.map((item) => {
          return { ...item };
        });

        setPermissions(formatted);
      }
    } catch (error) {
      console.error("Error fetching permissions:", error);
    } finally {
      setPermissionLoading(false);
    }
  };

  useEffect(() => {
    fetchPermissions();
  }, [selectedSubMenu, selectedModule, selectedRole]);

  const fetchsubMenu = async () => {
    try {
      const res = await fetch(
        `${ROLL_CALL_API_BASE_URL}portal/access/getSubMenu`,
        {
          method: "GET",
          headers: {
            "Content-Type": "application/json",
            Authorization: `Bearer ${tokenData}`,
          },
        }
      );
      const data = await res.json();

      if (data?.status && Array.isArray(data?.ResultData)) {
        setSubMenu(data.ResultData);
      }
    } catch (err) {
      console.error("Error fetching subMenu:", err);
    }
  };

  useEffect(() => {
    fetchsubMenu();
  }, []);

  const fetchRoles = async () => {
    try {
      const res = await fetch(
        `${ROLL_CALL_API_BASE_URL}portal/access/getRoles`,
        {
          method: "GET",
          headers: {
            "Content-Type": "application/json",
            Authorization: `Bearer ${tokenData}`,
          },
        }
      );
      const data = await res.json();
      if (data?.status && Array.isArray(data?.ResultData)) {
        setRoles(data.ResultData);
      }
    } catch (err) {
      console.error("Error fetching roles:", err);
    }
  };

  useEffect(() => {
    fetchRoles();
  }, []);

  const handleSubMenuChange = (value) => {
    setSelectedSubMenu(value);
  };

  const handleRoleChange = (value) => {
    setSelectedRole(value);
  };

  const handlePermissionChange = async (row, key, value) => {
    setUpdateLoading(true);

    const payload = {
      updateId: row.id,
      superId: 10000,
      permissions: {
        read: key === "read" ? (value ? 1 : 0) : row.Read ? 1 : 0,
        write: key === "write" ? (value ? 1 : 0) : row.Write ? 1 : 0,
        delete: key === "delete" ? (value ? 1 : 0) : row.Delete ? 1 : 0,
        export: key === "export" ? (value ? 1 : 0) : row.Export ? 1 : 0,
      },
    };

    try {
      const res = await fetch(
        `${ROLL_CALL_API_BASE_URL}portal/access/updatePermissions`,
        {
          method: "POST",
          headers: { "Content-Type": "application/json" },
          body: JSON.stringify(payload),
        }
      );

      if (!res.ok) {
        throw new Error("Failed to update permissions");
      }

      // after update → reload permissions
      await fetchPermissions();
    } catch (err) {
      console.error(err);
    } finally {
      setUpdateLoading(false);
    }
  };

  return (
    <div className="page-wrapper">
      {updateLoading && (
        <div
          style={{
            position: "fixed",
            top: 0,
            left: 0,
            width: "100vw",
            height: "100vh",
            backdropFilter: "blur(4px)",
            background: "rgba(255, 255, 255, 0.3)",
            zIndex: 9999,
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
          }}
        >
          <Spin size="large" />
        </div>
      )}

      <div className="content">
        {/* Header */}
        <div className="page-header">
          <div className="add-item d-flex">
            <div className="page-title">
              <nav aria-label="breadcrumb">
                <ol className="breadcrumb">
                  <li className="breadcrumb-item">
                    <Link to="/rollcall/dashboard">
                      <i className="fas fa-home fa-lg" />
                    </Link>
                  </li>
                  <h4 className="breadcrumb-item " aria-current="page">
                    Permissions
                  </h4>
                </ol>
              </nav>
              <h6>Configure access for plans, subMenu and roles</h6>
            </div>
          </div>
        </div>

        <div className="card table-list-card no-search">
          <div className="">
            <div className="card-header d-flex align-items-center justify-content-end flex-wrap row-gap-3">
              <div className="d-flex table-dropdown   align-items-center justify-content-end">
                <div className="dropdown me-2">
                  <div className="">
                    <i data-feather="package" className="info-img" />
                    <Select
                      placeholder="Select a module"
                      style={{ width: 200 }}
                      value={selectedModule}
                      onChange={handleModuleChange}
                      allowClear
                    >
                      {modules.map((item) => (
                        <Select.Option key={item.id} value={item.id}>
                          {item.modulename}
                        </Select.Option>
                      ))}
                    </Select>
                  </div>
                </div>

                {/* Module */}
                <div className="dropdown me-2 d-none">
                  <div className="">
                    <i data-feather="grid" className="info-img" />
                    <Select
                      placeholder="Select a Submenu"
                      style={{ width: 200 }}
                      value={selectedSubMenu}
                      onChange={handleSubMenuChange}
                      allowClear
                    >
                      <Select.Option value={null}>All</Select.Option>s
                      {subMenu.map((item) => (
                        <Select.Option key={item.id} value={item.id}>
                          {item.MenuName}
                        </Select.Option>
                      ))}
                    </Select>
                  </div>
                </div>

                {/* Role */}
                <div className="dropdown me-2">
                  <div className="">
                    <i data-feather="user" className="info-img" />
                    <Select
                      placeholder="Select a Role"
                      style={{ width: 200 }}
                      value={selectedRole}
                      onChange={handleRoleChange}
                      allowClear
                    >
                      {roles.map((item) => (
                        <Select.Option key={item.id} value={item.id}>
                          {item.rolename}
                        </Select.Option>
                      ))}
                    </Select>
                  </div>
                </div>
              </div>
            </div>

            {/* Table */}
            <div className="table-responsive">
              <table className="table datatable">
                <thead className="thead-light">
                  <tr>
                    <th className="no-sort">Screens</th>
                    <th>View</th>
                    <th>Update</th>
                    <th>Import</th>
                    <th>Export</th>
                  </tr>
                </thead>
                <tbody>
                  {/* {permissionLoading ? (
                    <tr>
                      <td colSpan={7} className="text-center py-3">
                        <Spin size="large" />
                      </td>
                    </tr>
                  ) : (
                    permissions.map((row) => (
                      <tr key={row.id}>
                        <td>{row.MenuName}</td>

                        <td>
                          <input
                            className="form-check-input"
                            type="checkbox"
                            checked={row.Read}
                          />
                        </td>
                        <td>
                          <input
                            className="form-check-input"
                            type="checkbox"
                            checked={row.Write}
                          />
                        </td>
                        <td>
                          <input
                            className="form-check-input"
                            type="checkbox"
                            checked={row.Delete}
                          />
                        </td>
                        <td>
                          <input
                            className="form-check-input"
                            type="checkbox"
                            checked={row.Export}
                          />
                        </td>
                      </tr>
                    ))
                  )} */}

                  {permissionLoading ? (
                    <tr>
                      <td colSpan={7} className="text-center py-3">
                        <Spin size="large" />
                      </td>
                    </tr>
                  ) : (
                    permissions.map((row) => (
                      <tr key={row.id}>
                        <td>{row.MenuName}</td>

                        {/* READ */}
                        <td>
                          <input
                            className="form-check-input"
                            type="checkbox"
                            checked={row.Read}
                            onChange={(e) =>
                              handlePermissionChange(
                                row,
                                "read",
                                e.target.checked
                              )
                            }
                          />
                        </td>

                        {/* WRITE */}
                        <td>
                          <input
                            className="form-check-input"
                            type="checkbox"
                            checked={row.Write}
                            onChange={(e) =>
                              handlePermissionChange(
                                row,
                                "write",
                                e.target.checked
                              )
                            }
                          />
                        </td>

                        {/* DELETE */}
                        <td>
                          <input
                            className="form-check-input"
                            type="checkbox"
                            checked={row.Delete}
                            onChange={(e) =>
                              handlePermissionChange(
                                row,
                                "delete",
                                e.target.checked
                              )
                            }
                          />
                        </td>

                        {/* EXPORT */}
                        <td>
                          <input
                            className="form-check-input"
                            type="checkbox"
                            checked={row.Export}
                            onChange={(e) =>
                              handlePermissionChange(
                                row,
                                "export",
                                e.target.checked
                              )
                            }
                          />
                        </td>
                      </tr>
                    ))
                  )}
                </tbody>
              </table>
            </div>
          </div>
        </div>
      </div>

      <div className="footer d-sm-flex align-items-center justify-content-between border-top bg-white p-3">
        <p className="mb-0">2014-2025 © Pereco. All Right Reserved</p>
        <p>
          Designed & Developed By{" "}
          <Link to="#" className="text-primary">
            Pereco
          </Link>
        </p>
      </div>
    </div>
  );
};

export default Permissions;
